export default __webpack_public_path__ + "static/7b58123f-5968-4e40-a0e0-6568b05ed816-7f8d51295b6e8c10c6a92a68586221da.ttf";